module.exports = __webpack_public_path__ + "static/img/total.2636e0c2.png";